import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { Swiper as ISwiper } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';

import '@ionic/vue/css/ionic-swiper.css';
import 'swiper/css';

import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';

import {
  IonCard,
  IonContent,
  IonFooter,
  IonHeader,
  IonImg,
  IonPage,
  IonTitle,
  IonToolbar,
  modalController,
  useIonRouter,
} from '@ionic/vue';

import CourseletContent from '@/components/Courselet/CourseletContent.vue';
import CourseletControls from '@/components/Courselet/CourseletControls.vue';
import QuizResultModal from '@/components/Courselet/Modals/QuizResultModal.vue';
import OptionsModal from '@/components/Courselet/Modals/OptionsModal.vue';
import ShareOptionsModal from '@/components/Common/ShareOptionsModal.vue';

import { useCourselet } from '@/composables/courselet';
import { useProgress } from '@/composables/progress';
import { useData } from '@/composables/data';
import { useCourseletStore } from '@/stores/courselet';
import { useChapterStore } from '@/stores/chapter';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChapterPage',
  setup(__props) {

const slider = ref<ISwiper>();
const ionRouter = useIonRouter();

const route = useRoute();
const courseId = Number(route.params.course as string);
const unitId = Number(route.params.unit as string);
const chapterId = Number(route.params.chapter as string);

const isFav = ref(false);

const { getChapterData } = useData();
const { lastCourseletIndex } = useProgress();
const { getSelectedAnswer } = useCourseletStore();
const { setCurrentChapter, setChapterCompleted, setChapterProgress } =
  useChapterStore();

const {
  activeCourselet,
  activeChapter: chapter,
  canSwipeNext,
  isLastSlide,
  isQuiz,
  setCompletedCourselet,
  setActiveCourselet,
  setActiveChapter,
} = useCourselet();

const setCurrentSlideAsRead = (): void => {
  if (chapter.value && activeCourselet.value) {
    setCompletedCourselet(activeCourselet.value);
    setChapterProgress(chapter.value.id, activeCourselet.value.id);
  }
};

const setInitialState = async (): Promise<void> => {
  const chapter = await getChapterData(courseId, unitId, chapterId);

  if (chapter) {
    setActiveChapter(chapter);

    const index = route.query.courselet
      ? Number(route.query.courselet)
      : lastCourseletIndex(chapter);

    if (index > -1) {
      setActiveCourselet(index);
    } else {
      setActiveCourselet(0);
    }
  }

  if (!isQuiz.value) {
    setCurrentSlideAsRead();
  }
};

onMounted((): void => {
  setInitialState();
});

const onSlideChange = (): void => {
  setActiveCourselet(slider.value?.activeIndex ?? 0);

  if (!isQuiz.value) {
    setCurrentSlideAsRead();
  }
};

const onSwiper = (swiperInstance: ISwiper): void => {
  slider.value = swiperInstance;

  if (chapter.value) {
    slider.value.activeIndex = lastCourseletIndex(chapter.value);
  }
};

const onCheckAnswer = async (): Promise<void> => {
  if (activeCourselet.value) {
    setCurrentSlideAsRead();

    // display result modal
    const modal = await modalController.create({
      component: QuizResultModal,
      initialBreakpoint: 0.5,
      backdropDismiss: false,
      handle: false,
      componentProps: {
        selected: getSelectedAnswer(activeCourselet.value.id),
        answers: activeCourselet.value.quiz.result.split(','),
      },
    });

    modal.present();

    await modal.onDidDismiss();

    slider.value?.slideNext();
  }
};

const onFinish = async (): Promise<void> => {
  if (chapter.value) {
    setCurrentChapter(chapter.value);
    setChapterCompleted(chapter.value.id);
  }

  if (isQuiz.value) {
    await onCheckAnswer();
  }

  ionRouter.navigate(
    `/course/${courseId}/unit/${unitId}/chapter/${chapterId}/finish`,
    'forward',
    'replace'
  );
};

const onFavToggle = (): void => {
  isFav.value = !isFav.value;
};

const openOptions = async (): Promise<void> => {
  const modal = await modalController.create({
    component: OptionsModal,
    initialBreakpoint: 0.5,
    canDismiss: true,
    backdropDismiss: true,
  });

  modal.present();
};

const openShareOptions = async (): Promise<void> => {
  const courseletIndex = slider.value?.activeIndex;
  const modal = await modalController.create({
    component: ShareOptionsModal,
    initialBreakpoint: 0.2,
    canDismiss: true,
    backdropDismiss: true,
    componentProps: {
      title: chapter.value?.name,
      text: `check our courses on ${process.env.VUE_APP_APP_NAME}!`,
      url: window.location.href.concat(`?courselet=${courseletIndex}`),
    },
  });

  modal.present();
};

const goBack = (): void => {
  ionRouter.navigate(`/course/${courseId}/unit/${unitId}`, 'back', 'push');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonImg), {
                class: "logo",
                slot: "start",
                src: "/assets/gk-logo.svg"
              }),
              _createVNode(_unref(IonTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(chapter)?.name), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(chapter)?.courselets)
        ? (_openBlock(), _createBlock(_unref(IonContent), {
            key: 0,
            class: "ion-padding",
            fullscreen: true
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(Swiper), {
                class: "fullheight",
                autoHeight: true,
                "allow-slide-next": _unref(canSwipeNext),
                direction: "vertical",
                onSlideChange: onSlideChange,
                onSwiper: onSwiper
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(chapter)?.courselets, (courselet, index) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonCard), null, {
                          default: _withCtx(() => [
                            _createVNode(CourseletContent, { courselet: courselet }, null, 8, ["courselet"])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["allow-slide-next"]),
              (slider.value)
                ? (_openBlock(), _createBlock(_unref(IonFooter), {
                    key: 0,
                    class: "ion-no-border"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(CourseletControls, {
                        "is-fav": isFav.value,
                        "is-quiz": _unref(isQuiz),
                        "last-slide": _unref(isLastSlide),
                        onBack: goBack,
                        onCheckAnswer: onCheckAnswer,
                        onFinish: onFinish,
                        onFavToggle: onFavToggle,
                        onOptions: openOptions,
                        onShare: openShareOptions
                      }, null, 8, ["is-fav", "is-quiz", "last-slide"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})